/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Hanki Bumble",
      "Hyväksy kaikki",
      "Hallitse valintoja",
      "Evästekäytäntö",
      "Mene takaisin",
      "Virheellinen puhelinnumero",
      "© {{current_year}} Bumble | Kaikki oikeudet pidätetään.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Yleistä",
      "Tuote-edustajat",
      "Buzz",
      "Tämä sivusto käyttää evästeitä. Jos et muuta asetuksia oletamme, että hyväksyt evästeiden käytön.",
      "Lataa sovellus",
      "Lataa Android-appi",
      "Lataa iOS-appi",
      "Valitettavasti etsimääsi sivua ei löytynyt.",
      "Kirjaudu sisään",
      "Liity",
      "Liity pesään!",
      "No voi, jotain on vialla"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "päivää",
                  "päivää",
                  "päivän",
                  "päivää",
                  "päivää",
                  "päivää",
                  "päivää",
                  "päivää",
                  "päivää",
                  "päivää",
                  "päivää",
                  "päivää",
                  "päivää",
                  "päivää",
                  "päivää"
            ],
            "singular": [
                  "päivä",
                  "päivä",
                  "päivän",
                  "päivä",
                  "päivä",
                  "päivä",
                  "päivä",
                  "päivä",
                  "päivä",
                  "päivä",
                  "päivä",
                  "päivä",
                  "päivä",
                  "päivä",
                  "päivä"
            ]
      },
      "hour": {
            "plural": [
                  "tuntia",
                  "tuntia",
                  "tunnin",
                  "tuntia",
                  "tuntia",
                  "tuntia",
                  "tuntia",
                  "tuntia",
                  "tuntia",
                  "tuntia",
                  "tuntia",
                  "tuntia",
                  "tuntia",
                  "tuntia",
                  "tuntia"
            ],
            "singular": [
                  "tunti",
                  "tunti",
                  "tunnin",
                  "tunti",
                  "tunti",
                  "tunti",
                  "tunti",
                  "tunti",
                  "tunti",
                  "tunti",
                  "tunti",
                  "tunti",
                  "tunti",
                  "tunti",
                  "tunti"
            ]
      },
      "minute": {
            "plural": [
                  "minuuttia",
                  "minuuttia",
                  "minuutin",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia",
                  "minuuttia"
            ],
            "singular": [
                  "minuutti",
                  "minuutti",
                  "minuutin",
                  "minuutti",
                  "minuutti",
                  "minuutti",
                  "minuutti",
                  "minuutti",
                  "minuutti",
                  "minuutti",
                  "minuutti",
                  "minuutti",
                  "minuutti",
                  "minuutti",
                  "minuutti"
            ]
      },
      "month": {
            "plural": [
                  "kuukautta",
                  "kuukautta",
                  "kuukauden",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta",
                  "kuukautta"
            ],
            "singular": [
                  "kuukausi",
                  "kuukausi",
                  "kuukauden",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi",
                  "kuukausi"
            ]
      },
      "second": {
            "plural": [
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia",
                  "sekuntia"
            ],
            "singular": [
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti",
                  "sekunti"
            ]
      },
      "year": {
            "plural": [
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta",
                  "vuotta"
            ],
            "singular": [
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi",
                  "vuosi"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
